import { LIVE_WINDOW } from '@/function/traffic/traffic.live.constants';
import trafficRequestsMerge from '@/function/traffic/traffic.requests.merge';
import { dashboardApi } from '@/store/api/base/api.base';
import type { TypeTrafficRequest } from '@/types/traffic/types.traffic.live';

type TypeTrafficRequests = {
    requests: TypeTrafficRequest[];
    cursor: string | null;
    more: boolean;
    gap: boolean;
    capacity: number;
    masked: boolean;
    skipped: number;
};

export const trafficLiveApi = dashboardApi.injectEndpoints({
    endpoints: (build) => ({
        readTrafficRequests: build.query<TypeTrafficRequests, void>({
            query: () => ({ url: '/traffic/requests', params: { limit: LIVE_WINDOW } }),
            transformResponse: (data: Omit<TypeTrafficRequests, 'skipped'>): TypeTrafficRequests => ({
                ...data,
                requests: trafficRequestsMerge([], data?.requests, LIVE_WINDOW),
                masked: data?.masked !== false,
                skipped: 0,
            }),
            keepUnusedDataFor: 0,
        }),
    }),
});

export const { useReadTrafficRequestsQuery } = trafficLiveApi;
